import React, { useEffect, useState } from "react";
import ProductSmallCard from "../Widgets/ProductSmallCard/ProductSmallCard";
import { ProductDetailsContainer } from "../ProductDetails/ProductDetailsContainer";

import { useDispatch, useSelector } from "react-redux";

import { useDrawer } from "../Drawer/DrawerContext";
import Styles from "./productsList.module.scss";
import { _SaveRedux, _addCartItem } from "../../redux/actions";
import { FixedSizeGrid as Grid } from "react-window";
import { FixedSizeList as List } from "react-window";
import ProductCard from "../Widgets/ProductCard";
import { generateItemsForCart } from "../../utils/cartController";

interface IProductListProps {
  /**any because of the funky typing with the cell */
  menuItemList: IMenuItem[] | any;
  listView: boolean;
  windowHeight?: number;
}

function calculateWindowList(wHeight: number) {
  let height = wHeight;
  if (height === undefined) {
    height = window.innerHeight;
  }
  let removePixel = 260;
  if (height <= 580) {
    removePixel = 215;
  }
  return height - removePixel;
}

const ProductList = ({
  menuItemList,
  listView,
  windowHeight,
}: IProductListProps) => {
  const [width] = useState(window.innerWidth || 425);
  const [height, setHeight] = useState(
    calculateWindowList(windowHeight) || 500
  );
  const [count] = useState(1);
  const dispatch = useDispatch();
  const { openDrawer, closeDrawer } = useDrawer()!;
  const menuItemAsExtra = useSelector((state: any) => state.MenuItemsAsExtra);
  useEffect(() => {
    if (windowHeight === undefined) {
      return;
    }
    setHeight(calculateWindowList(windowHeight));
  }, [windowHeight]);
  const Row = ({ index, style }: any) => {
    let newStyle = { ...style };
    return (
      <div style={newStyle} key={index}>
        <ProductCard
          productInfo={menuItemList[index]}
          onClick={() => _handleProductSelect(menuItemList[index])}
        />
      </div>
    );
  };

  const Cell = ({ columnIndex, rowIndex, style }: any) => {
    style["display"] = "flex";
    style["justifyContent"] = "center";
    style["alignItems"] = "center";

    return (
      <div style={style} className={Styles.item}>
        <ProductSmallCard
          info={menuItemList[rowIndex][columnIndex]}
          onClick={() =>
            _handleProductSelect(menuItemList[rowIndex][columnIndex])
          }
        />
      </div>
    );
  };
  /**Function to add to the cart */
  const _addToCard = (
    Extras: ISelectedCartExtras,
    Preferences: Record<string, string>,
    priceOptionName: string,
    price: number,
    productInfo: IMenuItem,
    count: number
  ) => {
    const cartBody = generateItemsForCart(
      Extras,
      Preferences,
      priceOptionName,
      price,
      productInfo,
      count,
      menuItemAsExtra
    );
    dispatch(_addCartItem(cartBody));

    // hideModal();
    closeDrawer();

    setTimeout(() => {
      dispatch(_SaveRedux());
    }, 100);
  };
  const _handleProductSelect = (menuItem: any) => {
    // setMenuItem(menuItem);
    openDrawer(
      ProductDetailsContainer as any,
      {
        addToCart: _addToCard,
        extraPrices: 0,
        count: count,
        menuItem,
        closeDrawer: closeDrawer,
      },
      "bottom",
      "ProductDetailsDrawer",
      true
    );
    // _openDrawer();
  };

  return (
    <div
      className={Styles.itemsListContainer}
      // style={{ marginTop: "-10px" }}
      id="itemsListContainerId"
    >
      {/* <div className={Styles.shadowTop}></div> */}
      {listView === true ? (
        <List
          height={height}
          itemCount={menuItemList.length}
          itemSize={100}
          width={"100%"}
          style={{
            paddingBottom: "12.5rem",
            overflow: "auto",
          }}
          className="menueItemsList"
        >
          {Row}
        </List>
      ) : (
        <Grid
          className="Grid"
          columnCount={3}
          columnWidth={width / 3}
          height={height}
          rowCount={menuItemList ? menuItemList.length : 0}
          rowHeight={170}
          width={width}
        >
          {Cell}
        </Grid>
      )}
    </div>
  );
};

export default ProductList;
